import { CartUpdatedEvent } from '@theme/events';

class CharacterBundle {
  constructor(root) {
    this.root = root;
    this.items = new Map();
    this.target = 0;

    this.offerInputs = root.querySelectorAll('.character-bundle__offer-input');
    this.itemEls = root.querySelectorAll('.character-bundle__item');
    this.countEl = root.querySelector('[data-ref="bundle-count"]');
    this.targetEl = root.querySelector('[data-ref="bundle-target"]');
    this.hiddenInput = root.querySelector('[data-ref="bundle-items-input"]');
    this.gridEl = root.querySelector('[data-ref="bundle-grid"]');
    this.errorEl = root.querySelector('[data-ref="bundle-error"]');
    this.errorCountEl = root.querySelector('[data-ref="bundle-error-count"]');

    this.form = root.closest('form');
    this.addToCartButton = this.form ? this.form.querySelector('[data-ref="add-to-cart-button"]') : null;

    this.offerInputs.forEach((input) => {
      input.addEventListener('change', () => this.onOfferChange());
    });

    this.itemEls.forEach((item) => {
      const minus = item.querySelector('.character-bundle__step--minus');
      const plus = item.querySelector('.character-bundle__step--plus');
      minus.addEventListener('click', () => this.adjustQty(item, -1));
      plus.addEventListener('click', () => this.adjustQty(item, 1));
    });

    this.onOfferChange();
    this.bindAddToCart();
  }

  onOfferChange() {
    const checked = this.root.querySelector('.character-bundle__offer-input:checked');
    this.target = checked ? parseInt(checked.dataset.quantity, 10) : 0;
    if (this.targetEl) this.targetEl.textContent = this.target;

    // Met à jour le titre affiché en direct, ex: "3 doudous"
    const offerNameEl = this.root.querySelector('[data-ref="offer-selected-name"]');
    if (offerNameEl && checked) offerNameEl.textContent = checked.dataset.title;

    this.items.clear();
    this.itemEls.forEach((item) => this.setQty(item, 0));
    this.updateCount();
    this.updateButtonPrice(checked);
  }

  updateButtonPrice(checkedOfferInput) {
    if (!checkedOfferInput || !this.addToCartButton) return;

    const priceEl = this.addToCartButton.querySelector('[data-ref="price"]');
    const comparePriceEl = this.addToCartButton.querySelector('[data-ref="compare-at-price"]');

    if (priceEl) {
      priceEl.textContent = checkedOfferInput.dataset.priceFormatted;
      priceEl.dataset.value = checkedOfferInput.dataset.price;
    }

    if (comparePriceEl) {
      if (checkedOfferInput.dataset.comparePriceFormatted) {
        comparePriceEl.textContent = checkedOfferInput.dataset.comparePriceFormatted;
        comparePriceEl.dataset.value = checkedOfferInput.dataset.comparePrice;
      } else {
        comparePriceEl.textContent = '';
        comparePriceEl.dataset.value = '';
      }
    }

    const container = this.addToCartButton.closest('.product-add-to-cart-button');
    if (container) container.dataset.price = checkedOfferInput.dataset.price;
  }

  adjustQty(item, delta) {
    const current = this.items.get(item.dataset.variantId) || 0;
    const total = this.getTotal();
    if (delta > 0 && total >= this.target) return;
    const next = Math.max(0, current + delta);
    this.setQty(item, next);
    this.updateCount();
  }

  setQty(item, qty) {
    const variantId = item.dataset.variantId;
    if (qty > 0) {
      this.items.set(variantId, qty);
    } else {
      this.items.delete(variantId);
    }
    item.querySelector('[data-ref="qty-value"]').textContent = qty;
    item.dataset.selected = qty > 0 ? 'true' : 'false';
    item.querySelector('.character-bundle__step--minus').disabled = qty <= 0;
  }

  getTotal() {
    let total = 0;
    this.items.forEach((qty) => (total += qty));
    return total;
  }

  updateCount() {
    this.clearError(); // efface l'erreur dès que le client recompose

    const total = this.getTotal();
    if (this.countEl) {
      this.countEl.innerHTML = `${total} / <span data-ref="bundle-target">${this.target}</span>`;
      this.countEl.dataset.complete = total === this.target ? 'true' : 'false';
    }
    this.itemEls.forEach((item) => {
      const plus = item.querySelector('.character-bundle__step--plus');
      const isSoldOut = item.classList.contains('character-bundle__item--soldout');
      if (isSoldOut) {
        plus.disabled = true;
      } else {
        plus.disabled = total >= this.target && (this.items.get(item.dataset.variantId) || 0) === 0;
      }
    });

    const itemsPayload = Array.from(this.items.entries()).map(([id, quantity]) => ({ id: parseInt(id, 10), quantity }));
    if (this.hiddenInput) this.hiddenInput.value = JSON.stringify(itemsPayload);
  }

 showError() {
    const missing = this.target - this.getTotal();
    if (this.gridEl) this.gridEl.classList.add('character-bundle__grid--error');
    if (this.errorEl) this.errorEl.hidden = false;
    if (this.errorCountEl) this.errorCountEl.textContent = missing;
    if (this.gridEl) this.gridEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  clearError() {
    if (this.gridEl) this.gridEl.classList.remove('character-bundle__grid--error');
    if (this.errorEl) this.errorEl.hidden = true;
  }

  bindAddToCart() {
    if (!this.addToCartButton) return;

    document.addEventListener(
      'click',
      (e) => {
        const clickedButton = e.target.closest('[data-ref="add-to-cart-button"]');
        if (!clickedButton || clickedButton !== this.addToCartButton) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const total = this.getTotal();
        if (total !== this.target) {
          this.showError();
          return;
        }

        this.submitBundle();
      },
      true
    );
  }

  submitBundle() {
    const items = Array.from(this.items.entries()).map(([id, quantity]) => ({ id: parseInt(id, 10), quantity }));

    this.addToCartButton.disabled = true;

    const cartDrawer = document.querySelector('cart-drawer');
    const sectionId = cartDrawer ? cartDrawer.dataset.sectionId : null;
    const sections = sectionId ? [sectionId, 'auto-gifts'].join(',') : '';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),
    })
      .then((res) => {
        if (!res.ok) return res.json().then((err) => Promise.reject(err));

        // Après l'ajout, on appelle /cart/update.js SANS changement réel (updates: {})
        // uniquement pour récupérer le HTML des sections déjà rendu par Shopify —
        // c'est le même mécanisme que cart-drawer-item.js utilise pour le changement de quantité.
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            updates: {},
            sections,
            sections_url: window.location.pathname,
          }),
        });
      })
      .then((res) => res.json())
      .then((parsedResponseText) => {
        if (parsedResponseText.errors) {
          document.dispatchEvent(
            new CustomEvent('toast:open', {
              detail: { type: 'error', message: parsedResponseText.errors },
            })
          );
          return;
        }

        document.dispatchEvent(
          new CartUpdatedEvent(
            {},
            {
              itemCount: parsedResponseText.item_count,
              source: 'character-bundle',
              sections: parsedResponseText.sections,
            }
          )
        );
      })
      .catch((err) => {
        console.error('Bundle add-to-cart error:', err);
        alert(err.description || "Une erreur est survenue lors de l'ajout au panier. Réessaie.");
      })
      .finally(() => {
        this.addToCartButton.disabled = false;
      });
  }
}

document.querySelectorAll('[data-ref="character-bundle"]').forEach((el) => new CharacterBundle(el));